export { getWindow } from './get-window';
